import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { WINDOW } from '@core/window.service';
import { AuthenticationLinkResponse } from 'src/app/web-api-client';

@Component({
  standalone: false,
  selector: 'gstar-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private readonly window = inject<Window>(WINDOW);
  private readonly authService = inject(AuthService);

  authRedirect = false;

  constructor() {
    const params = new URLSearchParams(location.search);
    this.authRedirect =
      params.has('code') ||
      params.has('loginSessionId') ||
      params.has('loginError');
  }

  submitHandler(): void {
    this.authService.clearTokenSession();
    this.authService
      .getAuthenticationLink()
      .subscribe((response: AuthenticationLinkResponse) => {
        if (response.url) {
          this.window.location.href = response.url;
        }
      });
  }
}
